import { Slide, Stack } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2"
import { ReactElement, ReactNode, useEffect, useState } from "react"

import { FILTER_PANEL_SLIDE_MS } from "../../constants/generalConstants"
import { useGetState } from "../../hooks/useGetState"
import { getShowSearchFilters } from "../../redux/preferencesSlice"
import { GRID_SPACING } from "../../themes/defaultThemeParams"
import AppPaper from "../surfaces/appPaper"

const FILTER_BAR_WIDTH = "320px"

interface IFilterPanelFrameProps {
    children: ReactNode
}
/**
 * Abstracts layout for the database search filter panel
 */
const FilterPanelFrame = ({
    children,
}: IFilterPanelFrameProps): ReactElement | null => {
    const showFilters = useGetState(getShowSearchFilters)
    const [disableSlide, setDisableSlide] = useState(true)

    useEffect(() => {
        if (disableSlide) {
            setDisableSlide(false)
        }
    }, [disableSlide])

    return showFilters ? (
        <Grid sx={{ width: FILTER_BAR_WIDTH }}>
            <Slide
                direction="left"
                in={showFilters}
                timeout={FILTER_PANEL_SLIDE_MS}
                appear={!disableSlide}
            >
                <AppPaper
                    sx={{
                        paddingY: 3,
                    }}
                >
                    <Stack spacing={GRID_SPACING}>{children}</Stack>
                </AppPaper>
            </Slide>
        </Grid>
    ) : null
}

export default FilterPanelFrame
